// extracted by mini-css-extract-plugin
module.exports = {"layout":"SlimPageLayout_layout__3OE2s","body":"SlimPageLayout_body__2hfgA"};